import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import {
  CLASSIFICATION_CHANGE_DIALOG_MESSAGE,
  InvoicingClassificationValue,
  classificationCssClass,
} from '../../company-form.classification';

export interface ClassificationChangeDialogData {
  // Null for a company that was never classified (Draft on submit): the dialog then shows the
  // single-chip "will be classified as" variant instead of the current → next transition.
  current: InvoicingClassificationValue | null;
  next: InvoicingClassificationValue;
}

// INI-13125: warning shown before saving an edit that moves a classified company to a different
// invoicing category. "Confirm changes" closes true (the save proceeds); "Keep editing" and the
// header X close false (nothing is saved). Structure and buttons follow the shared cf-dialog
// pattern (see company-group-dialog); the classification chips reuse the cd-status look.
@Component({
  selector: 'app-classification-change-dialog',
  template: `
    <div class="cf-dialog">
      <div class="cf-dialog__header">
        <h2 class="cf-dialog__title">{{ MESSAGE.TITLE }}</h2>
        <button type="button" class="cf-dialog__close" (click)="keepEditing()" aria-label="Close">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
      </div>

      <div class="cf-dialog__divider"></div>

      <div class="cf-dialog__body">
        <p class="ccd-body__text">{{ data.current ? MESSAGE.BODY : MESSAGE.BODY_NEW_CLASSIFICATION }}</p>
        <div class="ccd-body__row">
          <span *ngIf="data.current" class="cd-status cd-status--{{ classificationCssClass(data.current) }}">{{ data.current }}</span>
          <svg *ngIf="data.current" class="ccd-body__arrow" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M9.49508 5.99906
                C9.87508 5.99906 10.2651 6.14906 10.5551 6.43906
                L15.1451 11.0191
                C15.7251 11.599 15.7251 12.5491 15.1451 13.1391
                L10.5551 17.7291
                C9.97508 18.3091 9.02508 18.3091 8.43508 17.7291
                C7.85508 17.1491 7.85508 16.1991 8.43508 15.6091
                L11.9651 12.0891
                L8.43508 8.54906
                C7.85508 7.96906 7.85508 7.01906 8.43508 6.42906
                C8.73508 6.13906 9.11508 5.99906 9.49508 5.99906Z"
              fill="currentColor"/>
          </svg>
          <span class="cd-status cd-status--{{ classificationCssClass(data.next) }}">{{ data.next }}</span>
        </div>
      </div>

      <div class="cf-dialog__footer">
        <button type="button" class="rp-button rp-outlined rp-primary" (click)="keepEditing()">
          {{ MESSAGE.KEEP_EDITING }}
        </button>
        <button type="button" class="rp-button rp-filled rp-primary" (click)="confirm()">
          {{ MESSAGE.CONFIRM }}
        </button>
      </div>
    </div>
  `,
  styleUrls: ['./classification-change-dialog.component.scss'],
})
export class ClassificationChangeDialogComponent {
  readonly MESSAGE = CLASSIFICATION_CHANGE_DIALOG_MESSAGE;
  readonly classificationCssClass = classificationCssClass;

  constructor(
    public readonly dialogRef: MatDialogRef<ClassificationChangeDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public readonly data: ClassificationChangeDialogData,
  ) {}

  confirm(): void {
    this.dialogRef.close(true);
  }

  keepEditing(): void {
    this.dialogRef.close(false);
  }
}
